import React from 'react'
import { SEO } from '../../../../components/Seo/seo'
import { FormattedMessage, useIntl } from 'react-intl'
import { externalEntityGroups } from '../../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { FormLoader } from '../../../../components/Loader/FormLoader'
import Layout from '../../../../components/Dashboard/Layout/Layout'
import { Redirect, useParams } from 'react-router-dom'
import { NamedRoutes } from '../../../../routes'
import { ExternalEntityGroupProvider } from '../../../../ExternalEntityGroupContext'
import ExternalEntityGroupEditContent from '../../../../components/Dashboard/Subscription/ExternalEntityGroupEditContent'

const SingleExternalEntityGroupEdit = () => {
  let { id } = useParams()
  const intl = useIntl()

  return (
    <>
      {!!id && !!parseInt(id) ? <>
        <SEO title={intl.formatMessage({ id: 'ExternalEntityGroups.Edit.Title' })}
          pathname={window.location.origin}
          titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
          image={externalEntityGroups.image}
          description={intl.formatMessage({ id: 'ExternalEntityGroups.Edit.Title' })}
        />
        <AuthenticatedUserConsumer>
          {({ userDataLoading, userData, handleNotificationCall }) => (
            <>
              {!!userDataLoading && <FormLoader loading={true} />}
              {!!Object.keys(userData).length &&
                <>
                  {!!userData.is_admin ? <Layout content={
                    <ExternalEntityGroupProvider isEdit externalEntityGroupId={id}
                      handleNotificationCall={handleNotificationCall}>
                      <ExternalEntityGroupEditContent pageTitle={<FormattedMessage id='ExternalEntityGroups.Edit.Title' />} />
                    </ExternalEntityGroupProvider>
                  } /> : (!userDataLoading && <Redirect to={NamedRoutes.home} />)
                  }
                </>
              }
            </>
          )}
        </AuthenticatedUserConsumer>
      </> :
        <Redirect to={NamedRoutes.subscription.externalEntityGroups.list} />
      }
    </>
  )
}

export default SingleExternalEntityGroupEdit